import { Box, makeStyles } from "@material-ui/core";
import React from "react";

const sizeObjectMap = {
	large: { width: "50px", height: "50px", fontSize: "20px" },
	medium: { width: "35px", height: "35px", fontSize: "16px" },
	small: { width: "24px", height: "24px", fontSize: "10px" },
};

const useStyles = (size) =>
	makeStyles((theme) => ({
		preSaleIcon: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			width: sizeObjectMap[size].width,
			height: sizeObjectMap[size].height,
			borderRadius: "50%",
			backgroundColor: "#D50030",
			color: "#fff",
			fontSize: sizeObjectMap[size].fontSize,
			fontWeight: 600,
			lineHeight: 1,
		},
	}));

const PreSaleIcon = ({ size = "medium" }) => {
	const classes = useStyles(size)();

	return <Box className={classes.preSaleIcon}>PV</Box>;
};

export default PreSaleIcon;
